function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import compact from 'lodash/compact';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ConfirmationModal, MenuItem, TextField, Typography } from 'seagull';
import { requiredValidation } from 'validators';
import { routes } from "../../constants";
import { useGlobalContext, useIoContext } from "../../contexts";
import { handlePromise } from "../../infra/utils";
import { relationshipSummaryModel } from "../../models";
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import { getClientViewURL } from "../unAuthorizedPages/LoginScreen";

function getAgreementLinks(relationship) {
  return compact([{
    id: 'home',
    text: 'Visit client portal',
    link: routes.home
  }, {
    id: 'agreement',
    text: 'View agreement',
    link: routes.agreement(relationship.id)
  }, !relationshipSummaryModel.isTerminated(relationship) && {
    id: 'pm',
    text: 'Manage payment methods',
    link: routes.paymentMethods(relationship.id)
  }, {
    id: 'team',
    text: 'Add team member',
    link: routes.team
  }, {
    id: 'business',
    text: 'Change company name',
    link: routes.businessDetails
  }, {
    id: 'profile',
    text: 'Change contact details',
    link: routes.profile
  }, {
    id: 'invoices',
    text: 'View invoices',
    link: routes.invoices(relationship.id)
  }, {
    id: 'activity',
    text: 'View activity log',
    link: routes.activityLog(relationship.id)
  }]);
}

export default function ShareAgreementLinksModal(_ref) {
  let {
    relationship,
    dismissModal
  } = _ref;
  const {
    control,
    handleSubmit
  } = useForm({
    mode: 'all',
    defaultValues: {
      pathname: ''
    }
  });
  const {
    copyToClipboard
  } = useIoContext();
  const {
    showErrorToast,
    showSuccessToast
  } = useGlobalContext();
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    textAlignCenter: false,
    title: "Share direct link",
    "data-testid": "direct-links-modal",
    content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      "data-testid": "direct-links-title"
    }, "Invite", ' ', /*#__PURE__*/React.createElement(Typography, {
      as: "span",
      weight: "bold"
    }, relationshipSummaryModel.customerBusinessName(relationship)), ' ', "to:"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Controller, {
      control: control,
      name: "pathname",
      rules: requiredValidation(),
      render: p => /*#__PURE__*/React.createElement(TextField, _extends({
        select: true,
        label: "Choose action",
        testid: "select-direct-link"
      }, connectControllerToTextField(p)), getAgreementLinks(relationship).map(_ref2 => {
        let {
          id,
          text,
          link
        } = _ref2;
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: link,
          value: getClientViewURL(link),
          "data-testid": "direct-link-".concat(id)
        }, text);
      }))
    })),
    primaryButtonLabel: "Copy link",
    secondaryButtonLabel: "Cancel",
    onSecondaryButtonClick: dismissModal,
    onPrimaryButtonClick: handleSubmit(async _ref3 => {
      let {
        pathname
      } = _ref3;
      const [,, hasError] = await handlePromise(copyToClipboard(window.location.origin + pathname));

      if (hasError) {
        showErrorToast('Failed to copy link', 'copy-link-error');
      } else {
        showSuccessToast('Link was copied to clipboard', 'copy-link-success');
        dismissModal();
      }
    })
  });
}